import {
  CommonContext,
  EmployeeApi,
  environment,
  HomePageIcon,
  isBreakpointMobile,
  OfflineButton,
  PortalModeType,
  Typography,
  useBreakpoint,
  useUser,
} from '@abdoo/common';
import CachedIcon from '@mui/icons-material/Cached';
import { Button, CircularProgress, Grid } from '@mui/material';
import { useCallback, useContext } from 'react';
import { BsCalendar, BsFillCalendarFill, BsFillCalendarPlusFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';

interface HomeProps {
  isEntitlementHealthy: boolean;
}

export const HomeNavigation = ({ isEntitlementHealthy }: HomeProps) => {
  const { switchMode, isManager } = useUser(EmployeeApi);
  const onSwitchModeSuccess = () => {
    window.location.href = `${environment.managerFrontendUrl ?? ''}?modeSwitch=true`;
  };
  const switchToManagerMode = useCallback(() => {
    switchMode().mutation(PortalModeType.Manager, onSwitchModeSuccess);
  }, [switchMode]);

  const breakpoint = useBreakpoint();
  const isMobile = isBreakpointMobile(breakpoint);
  const { isOnline } = useContext(CommonContext);

  return isManager.isLoading && isOnline ? (
    <CircularProgress sx={{ mt: '10px' }} />
  ) : (
    <Grid
      item
      xs={12}
      marginTop={'0.25em'}
      display={'flex'}
      gap={isManager.data ? 0 : 7}
      justifyContent={isManager.data ? 'space-between' : 'center'}
    >
      <Button
        component={Link}
        variant="text"
        style={{ display: 'block', textAlign: 'center', float: 'left' }}
        to="/calendar"
      >
        {isEntitlementHealthy ? (
          <BsFillCalendarFill data-testid="HealthyCalendar" size={isMobile ? 38 : 48} />
        ) : (
          <BsCalendar
            data-testid="UnhealthyCalendar"
            opacity={0.6}
            size={isMobile ? 38 : 48}
          />
        )}
        <Typography
          isLoading={false}
          variant="button"
          sx={{ opacity: isEntitlementHealthy ? 'none' : 0.8 }}
        >
          Calendar
        </Typography>
      </Button>
      {isManager.data && (
        <HomePageIcon
          marginTop={isMobile ? '-2px' : '8px'}
          textColor={''}
          width={'90px'}
          text="Manager mode"
          icon={<CachedIcon fontSize="large" />}
          onClick={switchToManagerMode}
        ></HomePageIcon>
      )}
      <OfflineButton
        sx={{ width: '90px' }}
        component={Link}
        variant="text"
        style={{ display: 'block', textAlign: 'center', float: 'right' }}
        to="/addAbsence"
        noBorder={true}
        text={
          <>
            <BsFillCalendarPlusFill size={isMobile ? 38 : 48} />
            <Typography isLoading={false} variant="button">
              Add Absence
            </Typography>
          </>
        }
      />
    </Grid>
  );
};
